import { Component, OnInit, ViewChild } from '@angular/core';
import { KmsService } from 'src/app/areas/kms/kms.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { SwMassageConfirmComponent } from 'src/app/librarys/components/basic-components/sw-massage-confirm/sw-massage-confirm.component';
import { KmsEnum } from 'src/app/areas/kms/serves/kms-enum';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { isArray } from 'util';
declare var $, d3;
@Component({
  selector: 'app-center-node-query',
  templateUrl: './center-node-query.component.html',
  styleUrls: ['./center-node-query.component.css']
})
export class CenterNodeQueryComponent implements OnInit {
    // 删除确认组件
    @ViewChild("trim") trim: SwMassageConfirmComponent;

    // 定义图谱实体搜索输入数据
    searchNodeName = '';
    // 上一次搜索的参数
    lastSearchNodeName = '';
    // 实体列表
    instanceDatasList:any = [];

    // 搜索关系树数据
    searchRelationName = '';
    // 当前实体的关系树数据
    instanceRelationTree:any = [];
    // 当前实体的关系树数据是否加载中
    isRelationTreeLoading:boolean = false;
    // 当前实体搜索展示的关系树数据
    relationTreeData: any = [];
    multiNodeIds: any = [];
    // 选择后不参与查询的关系实体
    readonlySelfIds:any = [];
    // 当前选中的关系实体数据
    selectedRelationIds = [];

    // 图谱分类概念颜色
    mapColors = [];

    // 图谱是否显示加载中
    isLoading = false;

    // 当前选中的实体
    selectedNode:any = {};

    // 当前选中的关系
    selectedLink:any = {
        relation: {
            uuid: ''
        },
        source: {},
        target: {}
    };
    // 编辑关系组件传值
    relationParams:any = {
        upOrAdd: 'Add',           // 新增/编辑实体
        relationData: {}          // 编辑关系时需传递的参数
    }
    // 关系编辑组件title
    title = '';

    // 图谱拖动状态判断
    draggedStatus = 0;

    // 判断图谱是否是初始化加载(1为初始化，2为点击拖到实体)
    initMapStatus = 1;

    // 初始化D3画布
    d3Canvas = {
        simulation: null,  // 图谱的simulation
        svg: null,  // 画布
        width: null,
        height: null,  // 画布的宽高
        marker: null,  // 图谱marker
        defs: null,  // 箭头和图片初始化
        relMap_g: null,  // 其他元素初始化
        patterns: null,  // 图片元素初始化
        edges: null,  // 线元素组合的初始化
        links: null,  // 线初始化
        rect_g: null,  // 关系容器初始化
        rects: null,  // 关系文字背景框初始化
        texts: null,  // 关系名称初始化
        circles: null,  // 实体圆初始化
        circleText: null,  // 实体圆文字初始化
        config: {  // 图谱的基本配置参数
            label_r: 25,
            active_r: 30,
            r: 10, // 头像的半径 [30 - 45]
            linkTextColor: '#676767 ', // 链接线默认的颜色
            linkColor: '#dddddd', // 链接线默认的颜色
            linkBg: '#f8f8f8',
            strokeWidth: 2, // 头像外围包裹的宽度
        },
        time: setTimeout(() => {}, 1000)  // 图谱点击时间
    }
    // 是否展示图例
    showLegend = false;
    constructor(
        private create:SwCreateModalComponentService,
        private kmsService: KmsService,
        private routeInfo: ActivatedRoute,
        private message: SwMassageBoxService,
        private router: Router
    ) { }

    ngOnInit() {
        // 获取路由参数
        this.routeInfo.queryParams.subscribe((data: Params) => {
            if (data.selectData) {
                // 判断当前是否为从别的页面跳转
                const params = JSON.parse(data['selectData']);
                this.searchNodeName = params.name;
            }
            this.initMap();
            // 判断初始化时是否传入实体名称参数，传入，则进行查询操作
            if(!this.searchNodeName){
                this.searchNodeName = KmsEnum.Default_Path_Node.startNode;
            }
            // 查询概念树数据
            this.getOnlogyTreePageList();
        });
    }

    // 请求概念数据模型方法
    getOnlogyTreePageList() {
        this.kmsService.getConceptTreeData({}).subscribe(
            data => {
                if (data.code == 200) {
                    let colorConfig = KmsEnum.colorConfig;
                    let keys = Object.keys(colorConfig);
                    keys.forEach(e => {
                        let item = data.data.find(e1 => e1.name  == e);
                        if(item){
                            this.mapColors.push(
                                {
                                    conceptId: item.id,
                                    conceptName: item.name,
                                    bg: colorConfig[e], 
                                    br: colorConfig[e].replace(')',',0.6)')
                                }
                            )
                        }
                    });
                    if(this.searchNodeName){
                        this.getNodeByName();
                    }
                }
            }
        );
    }

    // 图谱检索框enter事件
    handelNodeSearch(event) {
        if (event.keyCode == '13') {
            this.selectedRelationIds = [];
            this.getNodeByName();
        }else{
            this.getInstanceList();
        }
    }

    // 图谱关系树点击事件
    handleVotedClick(event) {
        // 先剔除已选关系实体中不参与查询的实体，再进行查询操作
        this.selectedRelationIds = [];
        if(event.length>0){
            event.forEach(element => {
                let item = this.readonlySelfIds.filter(item => item == element.key);
                if(item.length == 0){
                    this.selectedRelationIds.push(element.key);
                }
            });
        }
        if(!$.trim(this.searchNodeName)){
            this.searchNodeName = this.lastSearchNodeName;
        }
        this.getNodeByName(true);
    }

    // enter键触发搜索关系树搜索
    handelEnterSearch(event) {
        if (event.keyCode == 13) {
            this.getRelationTreeByRelationName();
        }
    }

    // 根据实体名称查询图谱数据
    getNodeByName(isTreeNodeSelect?) {
        this.searchNodeName = $.trim(this.searchNodeName);
        if(!this.searchNodeName){
            this.message.danger('请输入实体名称！');
            return;
        }
        // 记录下当前搜索时的关键字（避免进行实体或关系相关操作后，需刷新图谱而缺少查询参数的问题）
        this.lastSearchNodeName = this.searchNodeName;
        this.initMapStatus = 1;
        this.isLoading = true;
        // 查询当前实体所有的关系数据
        if(isTreeNodeSelect){
            this.queryCenterNodeRelation();
        }else{
            this.getRelatedRelations(this.searchNodeName);
        }
    };

    // 根据中心节点查询实体关系信息
    queryCenterNodeRelation(){
        // 查询实体信息
        let Params = {
            startNode: this.searchNodeName,
            relationships: this.selectedRelationIds
        }
        this.kmsService.getNodeByParam(Params).subscribe(
            res => {
                // 清除图谱
                this.emptyMapDatas();
                if (res.code == 200) {
                    let datas = res.data;
                    if (datas) {
                        let links = [];
                        if(datas.relationships && datas.relationships.length>0){
                            // 将links中两个节点间的关系进行标号，用于绘制曲线
                            links = this.getLinkNumber(datas.relationships);
                            links = links.map(d => Object.create(d));
                        }
                        let nodes = [];
                        if(datas.nodes && datas.nodes.length>0){
                            nodes = datas.nodes.map(d => Object.create(d));
                        }
                        this.draggedStatus = 0;
                        this.showMap(nodes, links);
                    } else {
                        this.isLoading = false;
                        this.message.info('暂未录入该实体信息！');
                    }
                } else {
                    this.isLoading = false;
                    this.message.waring('暂未录入该实体信息！');
                }
            }
        );
    }

    // 清空图谱数据
    emptyMapDatas() {
        d3.select('.arrows').selectAll('marker').remove();
        d3.select('.arrows').selectAll('pattern').remove();
        d3.select('.relMap_g').selectAll('g').remove();
        d3.select('.relMap_g').selectAll('circle').remove();
        d3.select('.relMap_g').selectAll('text').remove();   
        // 隐藏实体菜单和关系菜单     
        $('.nodeMenus').fadeOut();
        $('.linkMenus').fadeOut();
        // 清除之前选中的实体及连线数据
        this.selectedNode = {};
        this.selectedLink = {
            relation: {
                uuid: ''
            },
            source: {},
            target: {}
        };
        // 清除推荐实体信息
        this.instanceDatasList = [];
        // 关闭关系编辑弹框
        $('.relationEdit').animate({
            'right': '-500'
        },800)
    }

    // 初始化图谱信息
    initMap() {
        // 画布的宽高
        this.d3Canvas.width = $('#knowledgeGraph').width();
        this.d3Canvas.height = $('#knowledgeGraph').height();
        // 图谱放大缩小
        d3.select("#knowledgeGraph").call(d3.zoom()
            .scaleExtent([1 / 2, 4])
            .on("zoom", this.zoomed));

        // 创建画布
        this.d3Canvas.svg = d3.select("#knowledgeGraph .svg g");

        // 箭头和图像初始化
        this.d3Canvas.defs = this.d3Canvas.svg.append("defs").attr("class", "arrows");
        // 其他元素初始化
        this.d3Canvas.relMap_g = this.d3Canvas.svg.append("g").attr("class", "relMap_g");
    }

    // 显示知识图谱方法
    showMap(nodes, links) {
        let _this = this;
        _this.showLegend = true;
        let ghConfig = _this.d3Canvas.config;
        _this.d3Canvas.simulation = d3.forceSimulation(nodes)
            .force("link", d3.forceLink(links).id(d => d.id))
            .force("center", d3.forceCenter(_this.d3Canvas.width / 2, _this.d3Canvas.height / 2)) //  图谱居中
            .force("charge", d3.forceManyBody().strength(-800))
            .force("link", d3.forceLink(links).distance(150)) // 线的长度
            .force("collision", d3.forceCollide(50))
            .force("x", d3.forceX())
            .force("y", d3.forceY());
        _this.d3Canvas.marker = _this.d3Canvas.defs.selectAll(".linkMarker")
            .data(links)
            .enter()
            .append("marker")
            .attr('id', function(d){
                return "marker-"+d.properties.uuid;
            })
            .attr("markerWidth", 10) //marker视窗的宽
            .attr("markerHeight", 10) //marker视窗的高
            .attr("refX", ghConfig.r + 4 * ghConfig.strokeWidth + 2) //refX和refY，指的是图形元素和marker连接的位置坐标
            .attr("refY", 4)
            .attr("orient", "auto") //orient="auto"设置箭头的方向为自动适应线条的方向
            .attr("markerUnits", "userSpaceOnUse") //marker是否进行缩放 ,默认值是strokeWidth,会缩放
            .append("path")
            .attr("d", "M 0 0 8 4 0 8Z") //箭头的路径 从 （0,0） 到 （8,4） 到（0,8）
            .attr("fill", ghConfig.linkColor);

        // 实体名称
        _this.d3Canvas.patterns = _this.d3Canvas.defs.selectAll("pattern.patternclass")
        .data(nodes)
            .enter()
            .append("rect")
            .attr("class", function (d) {
                return 'rect' + d.id;
            })
            .attr("x", "0")
            .attr("y", function (d) {
                if (d.properties.nodeName == _this.lastSearchNodeName) {
                    return 4 / 3 * ghConfig.active_r;
                } else {
                    return 4 / 3 * ghConfig.r;
                }
            })
            .attr("width", function (d) {
                if (d.properties.nodeName == _this.lastSearchNodeName) {
                    return 2 * ghConfig.active_r;
                } else {
                    return 2 * ghConfig.r;
                }
            })
            .attr("height", function (d) {
                if (d.properties.nodeName == _this.lastSearchNodeName) {
                    return 2 / 3 * ghConfig.active_r;
                } else {
                    return 2 / 3 * ghConfig.r;
                }
            })
            .attr("fill", function (d) {
                return '#fff';
            })
            .attr("opacity", function (d) {
                return 0.8;
            })
        _this.d3Canvas.patterns.append("text")
            .attr("class", function (d) {
                return 'text' + d.id;
            })
            .attr("x", function (d) {
                if (d.properties.nodeName == _this.lastSearchNodeName) {
                    return ghConfig.active_r;
                } else {
                    return ghConfig.r;
                }
            })
            .attr("y", function (d) {
                if (d.properties.nodeName == _this.lastSearchNodeName) {
                    return 5 / 3 * ghConfig.active_r;
                } else {
                    return 5 / 3 * ghConfig.r;
                }
            })
            .attr('text-anchor', 'middle')
            .attr("fill", function (d) {
                return '#333';
            })
            .style("font-size", function (d) {
                if (d.properties.nodeName == _this.lastSearchNodeName) {
                    return ghConfig.active_r / 3;
                } else {
                    return ghConfig.r / 3;
                }
            })
            .text(function (d) {
                return d.properties.name;
            });
        // 每条线是个容器，有线 和一个装文字的容器
        _this.d3Canvas.edges = _this.d3Canvas.relMap_g
            .selectAll("g.edge")
            .data(links)
            .enter()
            .append("g")
            .attr("class", function (d) {
                return "edges edge" + d.id;
            })
            .attr('fill', function (d) {
                return 'transparent';
            })
            .attr("transform", function (d) {
                return _this.getTransform(d.source, d.target, _this.getDis(d.source, d.target))
            });
        // 添加线
        _this.d3Canvas.links = _this.d3Canvas.edges.append("path")
            .attr("class", "links")
            .attr("id", function(d){
                return 'links-'+d.properties.uuid
            })
            .attr("d", d => {
                const startPoint  = {x: 0, y: 0};
                const endPoint = {x: _this.getDis(d.source, d.target), y: 0};
                if(d.properties.linkIndex ==  0){
                    // 第一条连接是直线
                    return "M" + startPoint.x + "," + startPoint.y + " L" + endPoint.x + "," + endPoint.y;
                }else{
                    // 其他连接是弧线
                    const i = Math.ceil(d.properties.linkIndex / 2);
                    // 奇数、偶数 线条分别分布在上、下
                    let isEven = d.properties.linkIndex % 2 == 0 ? -1 : 1;
                    // 起始、指向节点可能是反的，所以还需要乘以seEven
                    isEven = d.properties.seEven * isEven;
                    const controlPoint1 = {
                        x: startPoint.x + (endPoint.x - startPoint.x) / 3,
                        y: startPoint.y + isEven * i * 50 // 每条弧线有不同的高度
                    };
                    
                    const controlPoint2 = {
                        x: startPoint.x + 2 * (endPoint.x - startPoint.x) / 3,
                        y: endPoint.y + isEven * i * 50 // 每条弧线有不同的高度
                    };
                    
                    // 创建贝塞尔曲线
                    return d = `M${startPoint.x},${startPoint.y} 
                            C${controlPoint1.x},${controlPoint1.y} 
                            ${controlPoint2.x},${controlPoint2.y} 
                            ${endPoint.x},${endPoint.y}`;
                }
            })
            .style("marker-end", function(d){
                return "url(#marker-"+d.properties.uuid+")";
            })
            .attr('stroke', (d) => {
                var str = d.color ? "#" + d.color : ghConfig.linkColor;
                return str;
            });

        // 添加关系文字的容器
        _this.d3Canvas.rect_g = _this.d3Canvas.edges.append("g")
            .attr("class", "rect_g")
            .style("cursor", "pointer")
            .on("click", function(d){
                const p = [d3.event.x, d3.event.y];
                if (!d3.event.defaultPrevented) {
                    // 取消上次延时未执行的方法
                    clearTimeout(_this.d3Canvas.time);
                    // 执行延时
                    _this.d3Canvas.time = setTimeout(() => {
                       _this.drawRelationMenu(d,p);
                    }, 500);
                }
            });
        // 添加rect
        _this.d3Canvas.rects = _this.d3Canvas.rect_g.append("rect")
            .attr("y", d => {
                const startPoint  = {x: 0, y: 0};
                if(d.properties.linkIndex ==  0){
                    // 第一条连接是直线
                    return -10;
                }else{
                    //其他是弧线
                    const i = Math.ceil(d.properties.linkIndex / 2);
                    let isEven = d.properties.linkIndex % 2 == 0? -1 : 1;
                    isEven = d.properties.seEven * isEven;
                    return startPoint.y + isEven * i * 34 + isEven * (i - 1) * 5 - 10;
                }
            })
            .attr("height", 20)
            .attr("id", function(d){
                return 'linkRect-'+d.properties.uuid
            })
            .attr("fill", function (d) {
                return ghConfig.linkBg
            })
            .attr("stroke", function (d) {
                return ghConfig.linkColor
            })
            .attr('stroke-width', '1')
            .attr("rx", '10')
            .attr("ry", '15')

        // 关系名称  坐标（x,y）代表 文本的左下角的点
        _this.d3Canvas.texts = _this.d3Canvas.rect_g.append("text")
            .attr("text-anchor", "middle") // <text>文本中轴对齐方式居中  start | middle | end
            .style("font-size", 12)
            .attr("id", function(d){
                return 'linkText-'+d.properties.uuid
            })
            .text(d => {
                return d.properties.relationshipName
            })
            .attr("fill", function (d) {
                return ghConfig.linkTextColor
            })
            .attr("x", function (d) {
                // 7.3.1 根据字的长度来更新兄弟元素 rect 的宽度
                var bbox = d3.select(this).node().getBBox();
                var width = bbox.width;
                $(this).prev('rect').attr('width', width + 10);
                // 7.3.2 更新 text 的位置
                const on = d.target.x < d.source.x ? -1 : 1;
                // 7.3.2 更新 text 的位置
                return on * _this.getDis(d.source, d.target) / 2;
            })
            .attr("y", d => {
                const startPoint  = {x: 0, y: 0};
                if(d.properties.linkIndex ==  0){
                    // 第一条连接是直线
                    return 5;
                }else{
                    //其他是弧线
                    const i = Math.ceil(d.properties.linkIndex / 2);
                    let isEven = d.properties.linkIndex % 2 == 0? -1 : 1;
                    isEven = d.properties.seEven * isEven;
                    const on = d.target.x < d.source.x? -1 : 1;
                    isEven = on * isEven;
                    return startPoint.y + isEven * i * 34 + isEven * (i - 1) * 5 + 5;
                }
            })
            .attr("transform", function (d) {
                if (d.target.x < d.source.x) {
                    return 'rotate(180)';
                } else {
                    return 'rotate(0)';
                }
            });
        this.d3Canvas.patterns = this.d3Canvas.defs
            .selectAll("pattern.patternclass")
            .data(nodes)
            .enter()
            .append("pattern")
            .attr("class", "patternclass")
            .attr("id", function(d, index) {
                return 'avatar' + d.id;
            })
            // 两个取值userSpaceOnUse  objectBoundingBox
            .attr('patternUnits', 'objectBoundingBox')
            // <pattern>，x、y值的改变决定图案的位置，宽度、高度默认为pattern图案占填充图形的百分比。
            .attr("x", "10")
            .attr("y", "10")
            .attr("width", "1")
            .attr("height", "1");
        // 关系图实体圆
        _this.d3Canvas.circles = _this.d3Canvas.relMap_g.selectAll("circle.circleclass")
            .data(nodes)
            .enter()
            .append("circle")
            .attr("class", "circles")
            .attr("id", function(d){
                return 'circles-'+d.properties.nodeId
            })
            .style("cursor", "pointer")
            .attr("fill", function (d) {
                let conceptId = isArray(d.properties.mapping) ? d.properties.mapping[0] : d.properties.mapping.split(',')[0]
                let items = _this.mapColors.find(c => c.conceptId == conceptId);
                if (items) {
                    return items.bg;
                } else {
                    return '#999999';
                }
            })
            .attr("stroke", function (d) {
                let conceptId = isArray(d.properties.mapping) ? d.properties.mapping[0] : d.properties.mapping.split(',')[0]
                let items = _this.mapColors.find(c => c.conceptId == conceptId);
                if (items) {
                    return items.br;
                } else {
                    return '#999999';
                }
            })
            .attr("stroke-width", function (d) {
                return '8';
            })
            .attr("r", function (d) {
                if (d.properties.nodeName == _this.lastSearchNodeName) {
                    return ghConfig.active_r;
                } else {
                    return ghConfig.r;
                }
            })
            .attr("cx", function (d) {
                return d.x;
            })
            .attr("cy", function (d) {
                return d.y;
            })
            // 鼠标单击
            .on('click', function (d, i) {
                const p = [d3.event.x, d3.event.y];
                if (!d3.event.defaultPrevented) {
                    // 取消上次延时未执行的方法
                    clearTimeout(_this.d3Canvas.time);
                    // 执行延时
                    _this.d3Canvas.time = setTimeout(() => {
                       _this.drawNodeMenu(d,p);
                    }, 500);
                }
            })
            .call(_this.drag(_this.d3Canvas.simulation));
        _this.d3Canvas.circleText = _this.d3Canvas.relMap_g.selectAll("text.textclass")
            .data(nodes)
            .enter()
            .append("text")
            .attr('class', 'circletext')
            .attr("id", function(d){
                return 'circletext-'+d.properties.nodeId
            })
            .attr('font-size', 12)
            .style('fill', function (d) {
                return ghConfig.linkTextColor;
            })
            .attr("dominant-baseline", 'middle')
            .attr("text-anchor", "middle")//在圆圈中加上数据
            .text(function(d){
                return d.properties.nodeName.length > 10 ? d.properties.nodeName.slice(0,10)+'...' : d.properties.nodeName;
            })
            .attr("x", function (d) {
                return d.x;
            })
            .attr("y", function (d) {
                if (d.properties.nodeName == _this.lastSearchNodeName) {
                    return d.y + 45;
                } else {
                    return d.y + 30;
                }
            })
            .style("cursor", "pointer")
            // 鼠标单击
            .on('click', function (d) {
                const p = [d3.event.x, d3.event.y];
                if (!d3.event.defaultPrevented) {
                    // 取消上次延时未执行的方法
                    clearTimeout(_this.d3Canvas.time);
                    // 执行延时
                    _this.d3Canvas.time = setTimeout(() => {
                       _this.drawNodeMenu(d,p);
                    }, 500);
                }
            });

        // 图谱显示位置
        _this.d3Canvas.simulation.on("tick", () => {
            _this.updateMapLocation();
            // if (_this.draggedStatus === 1) {
            //     _this.updateMapLocation(links);
            //     return;
            // }
            // if (_this.initMapStatus == 1) {
            //     _this.isLoading = true;
            //     if (_this.d3Canvas.simulation.alpha() <= 0.05) {
            //         _this.isLoading = false;
            //         _this.updateMapLocation(links);
            //     }
            //     _this.initMapStatus = 2;
            // } else {
            //     if (_this.d3Canvas.simulation.alpha() <= 0.05) {
            //         _this.updateMapLocation(links);
            //     }
            // }
            
        });
        // return svg.node();
    }

    // 更新图谱位置方法
    updateMapLocation() {
        let _this = this;
        setTimeout(() => {
            _this.isLoading = false;
        },500)
        // 足够稳定时，才渲染一次
        _this.d3Canvas.rects
            .attr("x", function (d) {
                return _this.getDis(d.source, d.target) / 2 - $(this).attr('width') / 2
            }) // x 坐标为两点中心距离减去自身长度一半

        _this.d3Canvas.circles
            .attr("cx", function (d) {
                return d.x;
            })
            .attr("cy", function (d) {
                return d.y;
            })
        _this.d3Canvas.circleText
            .attr("x", function (d) {
                return d.x;
            })
            .attr("y", function (d) {
                if (d.properties.nodeName == _this.lastSearchNodeName) {
                    return d.y + 45;
                } else {
                    return d.y + 30;
                }
            })

        _this.d3Canvas.texts
            .attr("x", function (d) {
                // 7.3.1 根据字的长度来更新兄弟元素 rect 的宽度
                var bbox = d3.select(this).node().getBBox();
                var width = bbox.width;
                $(this).prev('rect').attr('width', width + 10);
                const on = d.target.x < d.source.x ? -1 : 1;
                // 7.3.2 更新 text 的位置
                return on * _this.getDis(d.source, d.target) / 2;
            })
            .attr("y", d => {
                const startPoint  = {x: 0, y: 0};
                if(d.properties.linkIndex ==  0){
                    // 第一条连接是直线
                    return 5;
                }else{
                    //其他是弧线
                    const i = Math.ceil(d.properties.linkIndex / 2);
                    let isEven = d.properties.linkIndex % 2 == 0? -1 : 1;
                    isEven = d.properties.seEven * isEven;
                    const on = d.target.x < d.source.x? -1 : 1;
                    isEven = on * isEven;
                    return startPoint.y + isEven * i * 34 + isEven * (i - 1) * 5 + 5;
                }
            })
            .attr("transform", function (d) {
                if (d.target.x < d.source.x) {
                    return 'rotate(180)';
                } else {
                    return 'rotate(0)';
                }
            });

        _this.d3Canvas.links
            .attr("d", d => {
                const startPoint  = {x: 0, y: 0};
                const endPoint = {x: _this.getDis(d.source, d.target), y: 0};
                if(d.properties.linkIndex ==  0){
                    // 第一条连接是直线
                    return "M" + startPoint.x + "," + startPoint.y + " L" + endPoint.x + "," + endPoint.y;
                }else{
                    // 其他连接是弧线
                    const i = Math.ceil(d.properties.linkIndex / 2);
                    let isEven = d.properties.linkIndex % 2 == 0? -1 : 1;
                    isEven = d.properties.seEven * isEven;
                    const controlPoint1 = {
                        x: startPoint.x + (endPoint.x - startPoint.x) / 3,
                        y: startPoint.y + isEven * i * 50 // 每条弧线有不同的高度
                    };
                    
                    const controlPoint2 = {
                        x: startPoint.x + 2 * (endPoint.x - startPoint.x) / 3,
                        y: endPoint.y + isEven * i * 50 // 每条弧线有不同的高度
                    };
                    console.log(isEven,d.properties.linkIndex,i,controlPoint1.y);
                    
                    // 创建贝塞尔曲线
                    return d = `M${startPoint.x},${startPoint.y} 
                            C${controlPoint1.x},${controlPoint1.y} 
                            ${controlPoint2.x},${controlPoint2.y} 
                            ${endPoint.x},${endPoint.y}`;
                }
            })

        _this.d3Canvas.edges
            .attr("transform", function (d) {
                return _this.getTransform(d.source, d.target, _this.getDis(d.source, d.target))
            });
    }

    // 图谱缩放相关函数
    zoomed() {
        $('.nodeMenus').fadeOut();
        $('.linkMenus').fadeOut();
        d3.select(".svgBox").attr("transform", "translate(" + d3.event.transform.x + "," + d3.event.transform.y +
            ") scale(" + d3.event.transform.k + "," + d3.event.transform.k + ")");
    }

    // 求元素移动到目标位置所需要的 transform 属性值
    getTransform(source, target, _dis) {
        var r;
        if (target.x > source.x) {
            if (target.y > source.y) {
                r = Math.asin((target.y - source.y) / _dis)
            } else {
                r = Math.asin((source.y - target.y) / _dis);
                r = -r;
            }
        } else {
            if (target.y > source.y) {
                r = Math.asin((target.y - source.y) / _dis);
                r = Math.PI - r;
            } else {
                r = Math.asin((source.y - target.y) / _dis);
                r -= Math.PI;
            }
        }
        r = r * (180 / Math.PI);
        return "translate(" + source.x + "," + source.y + ")rotate(" + r + ")";
    }

    // 求两点间的距离
    getDis(s, t) {
        return Math.sqrt((s.x - t.x) * (s.x - t.x) + (s.y - t.y) * (s.y - t.y));
    }

    // 图谱拖拽相关函数
    drag(simulation) {
        let _this = this;
        function dragstarted(d) {
            if (!d3.event.active) simulation.alphaTarget(0.3).restart();
            d.fx = d.x;
            d.fy = d.y;
        }

        function dragged(d) {
            $('.nodeMenus').fadeOut();
            $('.linkMenus').fadeOut();
            _this.draggedStatus = 1;
            d.fx = d3.event.x;
            d.fy = d3.event.y;
        }

        function dragended(d) {
            if (!d3.event.active) simulation.alphaTarget(0);
            d.fixed = true; // 图谱线的拖动
            // d.fy = null;
        }
        return d3.drag()
            .on("start", dragstarted)
            .on("drag", dragged)
            .on("end", dragended);
    }

    // 图谱节点点击事件：绘制节点目录
    drawNodeMenu(d,p){
        $('.linkMenus').fadeOut();
        this.toggleEditRelation(false);
        // 给之前选中的节点移除选中样式
        let lastSelectNode = this.selectedNode;
        if(lastSelectNode && lastSelectNode.nodeId){
            d3.select("#circles-"+lastSelectNode.nodeId)
              .attr('class', 'circles');
            d3.select("#circletext-"+lastSelectNode.nodeId)
              .attr('class', 'circletext');
        }
        this.selectedNode = d.properties;
        // 给当前选中的关系添加选中样式
        d3.select("#circles-"+this.selectedNode.nodeId)
            .attr('class', 'circles active');
        d3.select("#circletext-"+this.selectedNode.nodeId)
            .attr('class', 'circletext active');
        $('.nodeMenus').css({
            'left': p[0] * 0.6,
            'top': p[1] * 0.86
        }).fadeIn();
    }

    // 编辑实体
    editNode(){
        if(this.selectedNode.isDelete == 1){
            this.message.info('该实体已被删除，进入到回收站，不允许编辑！');
            return;
        }
        // 先判断审核状态 ，审核状态为已通过的实体不允许编辑
        this.kmsService.queryApprovalStatusById(this.selectedNode.nodeId).subscribe(
            data => {
                if(data.code == '200'){
                    if(data.data && data.data === 5){
                        this.message.info('当前实体已发布，不允许编辑!');
                    }else{
                        // 执行编辑操作
                        let selectData = {
                            addOrUpdate: 'Edit',
                            instanceId: this.selectedNode.nodeId,
                            conceptId: this.selectedNode.conceptId,
                            conceptName: this.selectedNode.conceptName,
                            serialNumber: this.selectedNode.serialNumber,
                        };
                        this.router.navigate(['/kms/InstanceAdd'],{ queryParams: { Title: '编辑实体信息', selectData: JSON.stringify(selectData) } });
                    }
                }else{
                    this.message.waring(data.msg);
                }
            }
        )
    }

    // 删除实体
    deleteNode(){
        if(this.selectedNode.isDelete == 1){
            this.message.info('该实体已被删除，进入到回收站！');
            return;
        }
        // 先判断审核状态 ，审核状态为已通过的实体不允许删除
        this.kmsService.queryApprovalStatusById(this.selectedNode.nodeId).subscribe(
            data => {
                if(data.code == '200'){
                    if(data.data && data.data === 5){
                        this.message.info('当前实体已发布，不允许删除!');
                    }else{
                        // 执行删除操作
                        this.trim.openCLick('确认删除"'+this.selectedNode.nodeName+'"吗？', (data) => {
                            if (data) {
                                this.kmsService.deleteInstanceById([this.selectedNode.nodeId]).subscribe(
                                    result => {
                                        if (result.code == 200) {
                                            this.message.success('删除成功！');
                                            this.searchNodeName = this.lastSearchNodeName;
                                            this.getNodeByName(true);
                                        }
                                    }
                                )
                            }
                        })
                    }
                }else{
                    this.message.waring(data.msg);
                }
            }
        )
    }

    // 查看实体
    viewNode(){
        let selectData = {
            instanceId: this.selectedNode.nodeId
        };
        this.router.navigate(
            ['/kms/InstanceView'],
            { queryParams: { Title: '查看实体信息', selectData: JSON.stringify(selectData) } }
        );
    }

    // 图谱关系点击事件：绘制关系目录
    drawRelationMenu(d,p){
        $('.nodeMenus').fadeOut();
        // 给之前选中的关系移除选中样式
        let lastSelectLink = this.selectedLink.relation;
        let _this = this;
        let ghConfig = _this.d3Canvas.config;
        if(lastSelectLink && lastSelectLink.uuid){
            d3.select("#links-"+lastSelectLink.uuid)
              .attr('stroke', (d) => {
                var str = d.color ? "#" + d.color : ghConfig.linkColor;
                return str;
            });
            d3.select("#linkRect-"+lastSelectLink.uuid)
                .attr("fill", function (d) {
                    return ghConfig.linkBg
                })
                .attr("stroke", function (d) {
                    return ghConfig.linkColor
                })
            d3.select("#linkText-"+lastSelectLink.uuid)
                .attr("fill", function (d) {
                    return ghConfig.linkTextColor
                })
            d3.select("#marker-"+lastSelectLink.uuid)
                .select('path')
                .attr("fill", ghConfig.linkColor);
        }
        // 给当前选中的关系添加选中样式
        d3.select("#links-"+d.properties.uuid)
            .attr('stroke', (d) => {
                return 'rgba(208, 32, 32, 0.6)'
            });
        d3.select("#linkRect-"+d.properties.uuid)
          .attr("fill",function(d){
            return 'rgb(208, 32, 32)'
          })
          .attr("stroke", function (d) {
            return 'rgba(208, 32, 32, 0.6)'
          });
        d3.select("#linkText-"+d.properties.uuid)
            .attr("fill", function (d) {
                return '#ffffff'
            });
        d3.select("#marker-"+d.properties.uuid)
            .select('path')
            .attr("fill", (d) => {
                return 'rgba(208, 32, 32, 0.6)'
            });
        this.selectedLink = {
            relation: d.properties,
            source: d.source.properties,
            target: d.target.properties
        }
        $('.linkMenus').css({
            'left': p[0] * 0.6,
            'top': p[1] * 0.86
        }).fadeIn();
    }

    // 关系编辑组件切换展示方法
    toggleEditRelation(state) {
        if(state){
            $('.relationEdit').animate({
                'right': '20'
            },800);
        }else{
            $('.relationEdit').animate({
                'right': '-500'
            },800)
        }
    }
    
    // 关系编辑回调
    relationEditCallback(event){
        this.toggleEditRelation(false);
        if(event == 'save'){
            this.searchNodeName = this.lastSearchNodeName;
            this.selectedRelationIds = [];
            this.getNodeByName();
        }
    }

    // 新增关系
    addRelation(){
        $('.linkMenus').fadeOut();
        this.toggleEditRelation(true);
        this.title = '新增关系';
        let params = {
            upOrAdd: 'Add',
            relationData: {
                isGraghAdd: true,
                sourceUUID: this.selectedLink.source.nodeId,
                sourceConceptId: this.selectedLink.source.conceptId,
                sourceConceptName: this.selectedLink.source.conceptName,
                sourceNodeName: this.selectedLink.source.nodeName
            }
        }
        this.relationParams = JSON.parse(JSON.stringify(params));
    }

    // 编辑关系
    editRelation(){
        $('.linkMenus').fadeOut();
        this.toggleEditRelation(true);
        this.title = '编辑关系';
        let params = {
            upOrAdd: 'Edit',
            relationData: {
                sourceUUID: this.selectedLink.source.nodeId,
                properties: this.selectedLink.relation
            }
        }
        this.relationParams = JSON.parse(JSON.stringify(params));
    }

    // 删除关系
    deleteRelation(){
        $('.linkMenus').fadeOut();
        // 删除方法
        let relation = this.selectedLink.relation;
        let source = this.selectedLink.source;
        let target = this.selectedLink.target;
        let params = [
            {
                startNodeId: source.nodeId,
                uuid: relation.uuid
            }
        ]
        this.trim.openCLick('确认删除“'+(source.nodeName + '—' + relation.relationshipName + '—' + target.nodeName)+'”吗？', (data) => {
            if (data) {
                this.kmsService.deleteRelationshipById(params).subscribe(
                    result => {
                        if (result.code == 200) {
                            this.message.success('删除成功！');
                            this.searchNodeName = this.lastSearchNodeName;
                            this.selectedRelationIds = [];
                            this.getNodeByName();
                        }
                    }
                )
            }
        })
    }

    // 查询实体列表信息数据
    getInstanceList() {
        let keyword = $.trim(this.searchNodeName);
        if(!keyword){
            this.instanceDatasList = [];
            return;
        }
        let Params = {
            current: 1,
            size: 30,
            instanceName: keyword
        };
        this.kmsService.getInstanceQueryList(Params).subscribe(
            result => {
                if (result.code == 200) {
                    this.instanceDatasList = result.data.records;
                } else {
                    this.message.waring(result.msg);
                }
            }
        );
    }

    // 实体输入框获取焦点时方法
    handleFocusFun() {
        this.getInstanceList();
    }

    // 实体输入框失去焦点时方法
    handleBlurFun() {
        setTimeout(() => {
            this.instanceDatasList = [];
        }, 200);
    }

    // 实体下拉搜索列表点击事件
    handleSearchInstanceClick(data) {
        this.instanceDatasList = [];
        // 设置查询参数，查询实体数据
        this.searchNodeName = data.instanceName;
        this.selectedRelationIds = [];
        this.getNodeByName();
    }

    // 根据实体名称查询该实体所有关联的关系信息
    getRelatedRelations(nodeName){
        // 数据重置
        this.isRelationTreeLoading = true;
        // 查询该实体关联的所有关系数据，并再关系树数据中筛选出所有的父级实体，渲染新的关系树
        this.kmsService.queryRelationsByNodeName(nodeName).subscribe(
            data => {
                this.isRelationTreeLoading = false;
                if(data.code == '200'){
                    // 获取该实体关联的所有关系数据
                    let res = Array.isArray(data.data) && data.data.length > 0 ? data.data : [];
                    this.searchRelationName = '';
                    this.instanceRelationTree = res;
                    this.relationTreeData = [];
                    this.readonlySelfIds = [];
                    this.selectedRelationIds = [];
                    this.multiNodeIds = [];
                    if(res.length == 0){
                        this.isLoading = false;
                        this.message.info('当前实体暂未录入任何关联关系！');
                        this.emptyMapDatas();
                        return;
                    }
                    let leafNodes = [];
                    this.instanceRelationTree.forEach(element => {
                        // 判断当前实体是否包含子实体，是，则不参与查询
                        let item = this.instanceRelationTree.filter(item => item.pid == element.id);
                        if(item.length>0){
                            this.readonlySelfIds.push(element.id);
                        }
                        // 关系数量>0,则为叶子实体
                        if(element.shipTotal>0){
                            leafNodes.push(element)
                        }else{
                            element.pid = 'root';
                            element.parentId = 'root';
                        }
                        this.multiNodeIds.push(element.id);
                        this.selectedRelationIds.push(element.id);
                    });
                    this.instanceRelationTree.push(
                        {
                            id: 'root',
                            text: '全部',
                            pid: '0',
                            shipTotal: 0
                        }
                    )
                    this.multiNodeIds.push('root');
                    this.selectedRelationIds.push('root');
                    this.readonlySelfIds.push('root');
                    // 遍历叶子实体，给它所有的父实体累加上当前实体的关系数
                    leafNodes.forEach(item => {
                        this.countShips(item);
                    })
                    this.instanceRelationTree.forEach(element => {
                        // 在关系名称后面拼接数量
                        element.text = element.text + "  (" + element.shipTotal + ")";
                    });
                    // 渲染新的关系树
                    this.relationTreeData = JSON.parse(JSON.stringify(this.instanceRelationTree));
                    // 加载图谱
                    this.queryCenterNodeRelation();
                }else{
                    this.message.waring(data.msg);
                }
            }
        )
    }

    // 给所有包含叶子实体的父实体加上叶子实体的关系数量
    countShips(child){
        let firstNode = [];
        let secondNode = [];
        let thirdNode = [];
        // 获取一级父实体，并修改关系数量
        firstNode = this.instanceRelationTree.filter(item => item.id == child.pid);
        if(firstNode.length>0){
            firstNode[0]['shipTotal'] += child.shipTotal;
            // 获取二级父实体，并修改关系数量
            secondNode = this.instanceRelationTree.filter(item => item.id == firstNode[0].pid);
            if(secondNode.length>0){
                secondNode[0]['shipTotal'] += child.shipTotal;
                // 获取三级父实体，并修改关系数量
                thirdNode = this.instanceRelationTree.filter(item => item.id == secondNode[0].pid);
                if(thirdNode.length>0){
                    thirdNode[0]['shipTotal'] += child.shipTotal;
                }
            }
        }
    }

    // 根据关系名筛选关系数据
    getRelationTreeByRelationName(){
        if(this.instanceRelationTree.length == 0){
            this.relationTreeData = [];
            return;
        }
        let data = JSON.parse(JSON.stringify(this.instanceRelationTree));
        let relationName = $.trim(this.searchRelationName);
        if(relationName){
            // 先判断是否存在当前关系
            var filterArr= data.filter(item => item.text.indexOf(relationName)>=0);
            if(filterArr.length == 0){
                this.relationTreeData = [];
                return;
            }
            let res = [];
            filterArr.forEach(item => {
                res = this.getParents(item,res);
            })
            this.relationTreeData = res;
        }else{
            this.relationTreeData = data;
        }
    }

    // 根据当前项获取所有父级
    getParents(item,parents){
        let data = JSON.parse(JSON.stringify(this.instanceRelationTree));
        if(parents.filter(item1 => item1.id == item.id).length == 0){
            parents.push(item);
        }
        let parentNode = data.filter(el => el.id == item.pid);
        if(parentNode.length == 0){
            return parents
        }else{
            return this.getParents(parentNode[0],parents);
        }
    }

    // 获取当前概念组实体下的所有子级关系实体(默认只查找三级)
    getChilds(pid){
        let res = [];
        let firstChilds = this.instanceRelationTree.filter(item => item.pid == pid);
        let secondChilds = [];
        let thirdChilds = [];
        // 获取一级关系实体
        if(firstChilds.length>0){
            res = res.concat(firstChilds);
            // 获取二级关系实体
            firstChilds.forEach(element => {
                secondChilds = this.instanceRelationTree.filter(item => item.pid == element.id);
                if(secondChilds.length > 0){
                    res = res.concat(secondChilds);
                    // 获取三级关系实体
                    secondChilds.forEach(element => {
                        thirdChilds = this.instanceRelationTree.filter(item => item.pid == element.id);
                        if(thirdChilds.length > 0){
                            res = res.concat(thirdChilds);
                        }
                    });
                }
            });
        }
        return res;
    }

    getLinkNumber(links){
        // 使用Map来聚合数据，键为排序后的source和target组成的字符串
        const aggregatedMap = new Map();
        links.forEach(item => {
            // 创建一个包含source和target的数组并排序
            const keyArray = [item.source, item.target].sort((a, b) => a - b);
            // 生成排序后的键字符串
            const key = `${keyArray[0]}-${keyArray[1]}`;
            
            if (!aggregatedMap.has(key)) {
                // 如果Map中没有该键，则初始化一个新数组
                aggregatedMap.set(key, []);
            }
            // 将当前项添加到对应的聚合数组中
            const i = aggregatedMap.get(key).length;
            item.properties.linkIndex = i;
            item.properties.seEven = i == 0 || item.source == aggregatedMap.get(key)[0].source ? 1 : -1;
            aggregatedMap.get(key).push(item);
        });
        // 将Map转换为数组
        let result = [];
        const keys = Array.from(aggregatedMap.keys());
        for (const key of keys) {
            // 按linkIndex从大到小排序，绘制时两个节点的关系从外层往里层绘制，里面的关系节点名称就不会被遮挡，可以点击选中
            const arr = aggregatedMap.get(key).sort((a, b) => b.properties.linkIndex - a.properties.linkIndex);
            result = result.concat(arr);
        }
        return result;
    }
}

